/* Tonic Alchemy theme behaviour: mobile nav, nav drop-downs, sticky buy bar. */
(function () {
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ta-toggle]');
    if (!t) return;
    var target = document.getElementById(t.getAttribute('data-ta-toggle'));
    if (!target) return;
    var open = target.hasAttribute('hidden');
    if (open) { target.removeAttribute('hidden'); } else { target.setAttribute('hidden', ''); }
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });


  /* Announcement bar rotation. Pauses on hover and respects reduced motion. */
  document.querySelectorAll('[data-ta-announce]').forEach(function (bar) {
    var items = bar.querySelectorAll('[data-ta-msg]');
    if (items.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0, paused = false;
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });
    var wait = (parseInt(bar.getAttribute('data-interval'), 10) || 5) * 1000;
    setInterval(function () {
      if (paused) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, wait);
  });

  var anchor = document.querySelector('[data-ta-buy-anchor]');
  var bar = document.querySelector('[data-ta-sticky-bar]');
  if (anchor && bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -40px 0px' }).observe(anchor);
  }
})();
